import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAIN_TABREQUESTS } from './tab-requests.routes';
import { MatTableModule } from '@angular/material/table';
import { MatChipsModule } from '@angular/material/chips';
import { PaginatorSelectModule } from 'src/app/components/paginatorselect/paginatorselect.module';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatInputModule } from '@angular/material/input';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { GeneralStepperModule } from '../general-stepper/general-stepper.module';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { TabRequestsComponent } from './tab-requests.component';
import { CardInfoBeneficiaryComponent } from './card-info-beneficiary/card-info-beneficiary.component';
import { ModalRejectComponent } from './modal-reject/modal-reject.component';
import { StatusRequirementModule } from './status-requirement/status-requirement.module';
import { BenefitDetailComponent } from './benefit-detail/benefit-detail.component';

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    TabRequestsComponent,
    CardInfoBeneficiaryComponent,
    ModalRejectComponent,
    BenefitDetailComponent,
  ],
  imports: [
    CommonModule,
    MAIN_TABREQUESTS,
    MatTableModule,
    MatChipsModule,
    MatButtonModule,
    MatIconModule,
    MatProgressBarModule,
    PaginatorSelectModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    FormsModule,
    MatDialogModule,
    GeneralStepperModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    StatusRequirementModule,
  ],
  exports: [TabRequestsComponent],
})
export class TabRequestsModule {}
